/* Source: /home/sidsolaiyappan/skooch_ai/shared/mobile_nav_logic.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
function computeActiveMobileTab(currentPage, aiPanelOpen) {
  if (aiPanelOpen) {
    return "chat";
  }
  if ((currentPage === "dashboard")) {
    return "today";
  }
  if ((currentPage === "scheduler")) {
    return "week";
  }
  if ((currentPage === "profile")) {
    return "profile";
  }
  return "";
}
function mobileTabClass(tab, activeTab) {
  return ((tab === activeTab) ? "mobile-tab mobile-tab-active" : "mobile-tab");
}
export {computeActiveMobileTab, mobileTabClass};
if (typeof globalThis !== "undefined") { if (!globalThis.__jacEndpointEffects__) globalThis.__jacEndpointEffects__ = {}; Object.assign(globalThis.__jacEndpointEffects__, {"func:computeActiveMobileTab": {"is_writer": false, "touches": ["*"]}, "func:mobileTabClass": {"is_writer": false, "touches": ["*"]}}); };
//# sourceMappingURL=mobile_nav_logic.js.map
